export default __webpack_public_path__ + "static/media/footercar.d6f587e2.png";